import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import _ from "lodash";
import { sendAsync } from "../../app/applicationSlice";
import { RootState, RootThunkApi } from "../../app/store";
import { Department, fromJson } from "../../models/department";
import { Page, pageOf, startPageOf } from "../../models/page";
import * as S from "../../services/department";
import {
  CreateDepartmentParams,
  GetDepartmentDetailParams,
  GetDepartmentListParams,
  ToggleDepartmentStateParams,
} from "../../services/department";

interface DepartmentState {
  page: Page<Department>;
}

const initialState: DepartmentState = {
  page: startPageOf(),
};

export const getDepartmentList = createAsyncThunk<
  Page<Department>,
  GetDepartmentListParams,
  RootThunkApi<Page<Department>>
>("department/getDepartmentListStatus", async (params, api) => {
  return sendAsync(S.getDepartmentList(params), api).then(
    (data: Record<string, never>) =>
      pageOf(
        data,
        _.chain(data.records)
          .map((d) => fromJson(d))
          .value()
      )
  );
});

export const createOrUpdateDepartment = createAsyncThunk<
  void,
  CreateDepartmentParams,
  RootThunkApi<void>
>("department/createOrUpdateDepartmentStatus", async (params, api) => {
  return sendAsync(S.createOrUpdateDepartment(params), api);
});

export const getDepartmentDetail = createAsyncThunk<
  Department,
  GetDepartmentDetailParams,
  RootThunkApi<Department>
>("department/getDepartmentDetailStatus", async (params, api) => {
  return sendAsync(S.getDepartmentDetail(params), api).then((data: unknown) =>
    fromJson(data)
  );
});

export const toggleDepartmentState = createAsyncThunk<
  void,
  ToggleDepartmentStateParams,
  RootThunkApi<void>
>("department/toggleDepartmentStateStatus", async (params, api) => {
  return sendAsync(S.toggleDepartmentState(params), api);
});

const depertmentSlice = createSlice({
  name: "department",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getDepartmentList.fulfilled, (state, action) => {
      state.page = action.payload;
    });
  },
});

export const selectDepartmentPage = (state: RootState): Page<Department> =>
  state.department.page;

export default depertmentSlice.reducer;
